import { render, staticRenderFns } from "./NewTomadorOrSubsidiary.vue?vue&type=template&id=149e9dec"
import script from "./NewTomadorOrSubsidiary.vue?vue&type=script&lang=js"
export * from "./NewTomadorOrSubsidiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports